
// Install flow: Chrome, Edge and Android get the browser's install prompt; iPhone gets Share-sheet steps.
const $$ = s => Array.from(document.querySelectorAll(s));
const ua = navigator.userAgent;
const isIOS = /iphone|ipad|ipod/i.test(ua) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
const isAndroid = /android/i.test(ua);
const standalone = matchMedia("(display-mode: standalone)").matches || navigator.standalone === true;
const platform = isIOS ? "ios" : isAndroid ? "android" : "desktop";
let deferred = null;

for (const card of $$(`[data-platform="${platform}"]`)) { card.classList.add("mine"); card.querySelector("[data-mine]").hidden = false; }

function setStatus(text) { const s = document.querySelector("[data-install-status]"); if (s) { s.textContent = text; s.hidden = !text; } }
function setLabel(text) { for (const l of $$("[data-install-label]")) l.textContent = text; }

if (standalone) { setLabel("Open Curbsend"); }
window.addEventListener("beforeinstallprompt", e => { e.preventDefault(); deferred = e; setLabel("Install the app"); });
window.addEventListener("appinstalled", () => { deferred = null; setLabel("Open Curbsend"); setStatus("Installed. Find Curbsend on your home screen."); });

const sheet = document.querySelector("[data-ios-sheet]");
sheet.addEventListener("click", e => { if (e.target === sheet || e.target.closest("[data-close]")) sheet.hidden = true; });

for (const b of $$("[data-install]")) b.addEventListener("click", async () => {
  if (standalone) { location.href = "/"; return; }
  if (deferred) {
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    deferred = null;
    if (outcome === "accepted") setStatus("Installing. Curbsend will appear on your home screen.");
    return;
  }
  if (isIOS) { sheet.hidden = false; return; }
  document.getElementById("install").scrollIntoView({ behavior: "smooth" });
  setStatus(platform === "desktop" ? "Use the install icon in your browser's address bar, or follow the steps below." : "Open your browser menu and tap Install app.");
});

// Pricing toggle
for (const b of $$("[data-period]")) b.addEventListener("click", () => {
  const yearly = b.dataset.period === "year";
  for (const x of $$("[data-period]")) x.setAttribute("aria-pressed", String(x === b));
  for (const p of $$("[data-price]")) p.textContent = "$" + p.dataset.price.split(",")[yearly ? 0 : 1];
  for (const p of $$("[data-billed]")) p.textContent = p.dataset.billed.split("|")[yearly ? 0 : 1];
});

for (const y of $$("[data-year]")) y.textContent = String(new Date().getFullYear());

// The service worker makes the page installable and lets the app open offline.
if ("serviceWorker" in navigator && location.protocol === "https:") navigator.serviceWorker.register("/sw.js").catch(() => {});
